<template>
  <v-card
    @click.stop="showActions = !showActions"
    width="100%"
    :min-height="minHeight"
  >
    <v-card-text width="100%" class="caption pa-2" v-html="text" />

    <v-expand-transition>
      <v-card-actions v-if="showActions" class="mx-5">
        <v-icon
            large
            @click.stop="edit"
            color="orange"
        >
          mdi-pen
        </v-icon>
        <v-spacer/>
        <v-icon
          large
          @click.stop="remove"
          color="red"
        >
          mdi-delete
        </v-icon>
      </v-card-actions>
    </v-expand-transition>

  </v-card>
</template>

<script>
export default {
  name: 'TextCard',
  props: {
    text: {
      type: String,
      default: 'empty',
    },
    minHeight: {
      type: Number,
      default: 200,
    },
  },
  data: () => ({
    showActions: false,
  }),

  methods: {
    remove() {
      this.$confirm('Are you sure you want to clear this text?').then((res) => {
        if (!res) return;
        this.$emit('remove');
      });
    },

    edit() {
      this.$emit('edit');
    },
  },
};
</script>
